export default __webpack_public_path__ + "static/media/Flag-id.a4112116.svg";